<script setup lang="ts">
const props = defineProps<{
  resourceId: number
  resourceType: ResourceType
  vertical?: boolean
}>()
const $toast = useToast()
async function handleClick() {
  const { data: userInfo } = useAuth()
  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }
  useEmitter().emit('openForwardForm', {
    resourceId: props.resourceId,
    resourceType: props.resourceType
  })
}
</script>

<template>
  <m-icon
    class="m-forward-action pointer"
    icon="lucide-share"
    :vertical="vertical"
    @click="handleClick"
  >
    <slot />
  </m-icon>
</template>
